import { render } from "./ImportColumnMapping.vue?vue&type=template&id=02cc3df1&scoped=true"
import script from "./ImportColumnMapping.vue?vue&type=script&lang=js"
export * from "./ImportColumnMapping.vue?vue&type=script&lang=js"

import "./ImportColumnMapping.vue?vue&type=style&index=0&id=02cc3df1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cc3df1"]])

export default __exports__